/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { all, call, spawn } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { sagas as libSagas } from '@wit/vtv-x-foundation-lib';
import tempCoreSagas from 'core/store/saga';
import * as LayoutProgressBar from './ducks/layoutProgressBar';
import * as StartUp from './ducks/startUp';
import * as OnDemand from './ducks/onDemand';
import * as WatchTv from './ducks/watchTv';
import * as MyTv from './ducks/myTv';
import * as Player from './ducks/player';
import * as ProgramInfo from './ducks/programInfo';
import * as Search from './ducks/search';
import * as Settings from './ducks/settings';
import * as FolderInfo from './ducks/folderInfo';
import * as VisualScrubber from './ducks/visualScrubber';
import * as Analytics from './ducks/analytics';

// this aproach have the following advantages:
// - root saga is always alive
// - uncatched errors/exceptions in a specific saga have no impact on the main root saga
// - even after the death of a specific saga, it will be executed again

function* keepEffectRunning(sagaCallEffect: unknown) {
  while (true) {
    try {
      yield sagaCallEffect;
      break;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Saga error: ', error);
    }
  }
}

export default function* rootSaga(): SagaIterator {
  const sagasCallEffects = [
    ...libSagas,
    ...tempCoreSagas,
    call(LayoutProgressBar.saga),
    call(StartUp.saga),
    call(OnDemand.saga),
    ...WatchTv.sagas,
    ...MyTv.sagas,
    call(Player.saga),
    ...ProgramInfo.sagas,
    ...FolderInfo.sagas,
    ...VisualScrubber.sagas,
    call(Search.saga),
    ...Settings.sagas,
    ...Analytics.sagas,
  ];

  // run each saga in a dedicated detached task
  yield all(sagasCallEffects.map((sagasCallEffect) => spawn(keepEffectRunning, sagasCallEffect)));
}
